export default () => {
    if (typeof window === 'undefined') return;
  
    window.clevertap = {
      event: [],
      profile: [],
      account: [],
      onUserLogin: [],
      region: 'sg1',
      notifications: [],
      privacy: []
    };
  
    window.clevertap.account.push({ id: '8WR-8KW-566Z' });
    window.clevertap.privacy.push({ optOut: false });
    window.clevertap.privacy.push({ useIP: true });
  
    let cleverTapLoaded = false;

    function initCleverTap() {
      if (cleverTapLoaded) return;
      cleverTapLoaded = true;
      
      // Remove all event listeners once CleverTap is loaded
      window.removeEventListener('click', initCleverTap);
      window.removeEventListener('scroll', initCleverTap);
      window.removeEventListener('touchstart', initCleverTap);
      window.removeEventListener('touchend', initCleverTap);
      window.removeEventListener('touchmove', initCleverTap);
      window.removeEventListener('pointerdown', initCleverTap);
      window.removeEventListener('pointerup', initCleverTap);
      document.removeEventListener('visibilitychange', initCleverTap);
      
      if ('requestIdleCallback' in window) {
        requestIdleCallback(loadCleverTap);
      } else {
        setTimeout(loadCleverTap, 100);
      }
    }

    function setupEventListeners() {
      // Add event listeners for user interactions (desktop and mobile)
      window.addEventListener('click', initCleverTap, { once: true, passive: true });
      window.addEventListener('scroll', initCleverTap, { once: true, passive: true });
      window.addEventListener('touchstart', initCleverTap, { once: true, passive: true });
      window.addEventListener('touchend', initCleverTap, { once: true, passive: true });
      window.addEventListener('touchmove', initCleverTap, { once: true, passive: true });
      window.addEventListener('pointerdown', initCleverTap, { once: true, passive: true });
      window.addEventListener('pointerup', initCleverTap, { once: true, passive: true });
      document.addEventListener('visibilitychange', initCleverTap, { once: true });
      
    }

    // Ensure DOM is ready before adding listeners
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', setupEventListeners);
    } else {
      setupEventListeners();
    }

    setTimeout(() => {
      initCleverTap();
    }, 5000); // Reduced to 5 seconds for testing

    const loadCleverTap = () => {
      const script = document.createElement('script');
      script.async = true;
      script.type = 'text/javascript';
      script.src = location.protocol === 'https:'
        ? 'https://d2r1yp2w7bby2u.cloudfront.net/js/clevertap.min.js'
        : 'http://static.clevertap.com/js/clevertap.min.js';
  
      const firstScript = document.getElementsByTagName('script')[0];
      firstScript.parentNode.insertBefore(script, firstScript);
    };
  };
